import {
  getBasePath,
  setBasePath
} from "../chunks/chunk.3Y6SB6QS.js";
import "../chunks/chunk.B3BW2AY6.js";
export {
  getBasePath,
  setBasePath
};
